import React, { useContext, useEffect, useState } from 'react';
import { CButton, CCard, CCardBody, CCol, CRow } from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import { getBoothsByMerchantId } from 'src/services/Booths/Booths';
import { DataGrid } from '@mui/x-data-grid';
import Authentication, { AUTH_KEY } from 'src/utils/auth/Authentication';
import { AuthContext } from 'src/App';

function Booths() {
  const navigate = useNavigate();
  const Auth = useContext(AuthContext)

  const [boothList, setBoothList] = useState([]);
  const [renderCounter, setRenderCounter] = useState(0);
  const [loading, setLoading] = useState(true);
  const [boothRows, setBoothRows] = useState([]);

  const boothColumns = [
    { field: 'id', headerName: 'Booth ID', width: '100' },
    { field: 'merchantName', headerName: 'Merchant Name', width: '100' },
    { field: 'merchantAddress', headerName: 'Merchant Address', width: '100' },
    { field: 'merchantID', headerName: 'Merchant ID', width: '100' },
    { field: 'price', headerName: 'price', width: '100' },
    { field: 'printCount', headerName: 'Print Count', width: '100' },
    { field: 'rollCount', headerName: 'Roll Count', width: '100' },
    { field: 'maintenance', headerName: 'Maintenance', width: '100' },
    { field: 'brandID', headerName: 'Brand ID', width: '100' },
    { field: 'picName', headerName: 'PIC Name', width: '100' },
    { field: 'picPhone', headerName: 'PIC Phone', width: '100' }
  ];

  async function fetchBooths() {
    const data = await getBoothsByMerchantId();

    const rows = data.data.map((item, i) => {
      return {
        id: item.id,
        merchantName: item.name,
        merchantAddress: item.address,
        merchantID: item.merchant_id,
        price: item.price,
        printCount: item.print_count,
        rollCount: item.roll_count,
        maintenance: item.maintenance,
        brandID: item.brand_id,
        picName: item.pic_name,
        picPhone: item.pic_phone
      };
    });

    setBoothRows(rows);

    setBoothList(data.data);
  }

  useEffect(() => {
    if (renderCounter === 0) {
      fetchBooths();
    }

    setRenderCounter(renderCounter + 1);
  }, [loading]);

  function handleRowClick(params) {
    navigate('/booth-actions', { state: { item: params.row } });
  }

  return (
    <>
      <CCard>
        { Auth.isAllowed(Auth.role[AUTH_KEY.booth_actions]) &&
            <CButton
                onClick={() => navigate('/booth-actions')}
                style={{ backgroundColor: '#4E5B97', border: 'none', width: '15vw' }}
                >
                Add Booths
            </CButton>
        }
        <CCardBody>

          <DataGrid
            rows={boothRows}
            columns={boothColumns}
            onRowClick={handleRowClick}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 10 }
              }
            }}
            pageSizeOptions={[5, 10, 20, 25]}
            style={{ textAlign: 'center' }}
          />
        </CCardBody>
      </CCard>
    </>
  );
}

export default Booths;
